<ng-container [formGroup]="fg">
  <div
    class="select-box"
    [style.color]="textColor"
    [style.font-family]="fontFamily"
    [style.font-size.px]="fontSize ? fontSize : null"
    (clickOutside)="closeToggleList()"
    attachOutsideOnClick="true"
    emitOnBlur="true"
  >
    <label
      appConfigSettingsParagraph
      (mouseover)="hasFocus = true"
      (mouseout)="hasFocus = false"
      (focusin)="hasFocus = true"
      (focusout)="hasFocus = false"
      [style.color]="fontColor ? fontColor : null"
    >
      <div
        class="displayInLine"
      >
        <p>{{ placeholder | translate }}</p>
        <div *ngIf="additionalInfoInsurer !== null">
          <mat-icon class="infoIcon"  (click)="toggleListVisibility(); openPopup()" type="button">info</mat-icon>
        </div>
      </div>

      <button
        class="selected-option-box"
        appConfigSettingsBorder
        appConfigSettingsInput
        [style.borderColor]="inputBorderColor ? inputBorderColor : null"
        [style.color]="inputColor ? hasFocus ? backgroundHoverTextColor : inputColor : null"
        [style.background]="hasFocus ? backgroundHoverColor : null"
        (click)="toggleListVisibility()"
        [disabled]="isDisabled"
        [class.disabled]="isDisabled"
      >
        <span class="selected-option">{{ currentlySelectedOption?.text || ( defaultOptionCaptionKey | translate ) }}</span>
        <mat-icon>expand_more</mat-icon>
      </button>
    </label>

    <div class="option-list-wrapper" [class.show]="isOptionListVisible" [class.force-overflow]="forceOptionListOverflow">
      <ul #optionList class="option-list" [class.force-overflow]="forceOptionListOverflow">
        <li *ngFor="let option of optionsList">
          <button
            appConfigSettingsInput
            #optionListItemElement
            class="option-item"
            (click)="selectValue(option)"
          >
            <span class="option-caption">
              <ng-container *ngIf="itemTemplate else defaultCaption">
                <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option}"></ng-container>
              </ng-container>

              <ng-template #defaultCaption>
                <strong class="default-option">{{ option.text }}</strong>
              </ng-template>
            </span>

            <span
              class="option-cta"
              appConfigSettingsBackground
              *ngIf="showCallToActionButton === true"
            >
              {{ callToActionCaptionKey | translate }}
            </span>
          </button>
        </li>
      </ul>
    </div>

    <mat-error *ngIf="isAnyError" class="error-message">
      <ng-container *ngIf="control.errors?.message">
        {{ control.errors.message }}
      </ng-container>
      <ng-container *ngIf="control.errors?.required">
        {{ isRequiredMessage }}
      </ng-container>
    </mat-error>
  </div>
</ng-container>
